const messages = {
    welcome: 'Welcome',
    otp_info_message: 'Please enter your phone number',
    send_code: 'Send Code',
};

export default messages;
